import adblockDetect from 'adblock-detect';
import clientIdCustom from './tracking/clientIdCustom';
import { getGoogleAnalyticsClientIds } from './tracking/googleAnalytics';
import api from './callApi';

export const adBlockCheck = new Promise((resolve, reject) => {
    adblockDetect(resolve);
});

export const trackAdBlock = (widgetData, page) => {
    const data = {
        type: 'NotDisplayed',
        articleId: widgetData.articleId,
        articleUrl: page.articleUrl,
        widgetId: widgetData.widgetId,
        publisherId: widgetData.publisherId,
        publishedDate: widgetData.publishedDate,
        widgetType: widgetData.widgetType,
        widgetEmbedType: page.embedType,
        sponsored: widgetData.isSponsored,
        ...getGoogleAnalyticsClientIds(),
        clientIdCustom,
        actions: []
    };
    return api.post('Widget/TrackingAsync', data);
};
